<template>
  <div>
    <el-dialog
      :title="$l('form_label_Exportdata') || '导出数据'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="formData"
        size="small"
        label-width="50px"
        label-position="left"
        :rules="rules"
      >
        <el-row :gutter="20">
          <el-col :span="24" class="mt-3">
            <el-form-item
              :label="$l('table_label_dateRange') || '日期'"
              prop="dateRange"
            >
              <el-date-picker
                v-model="formData.dateRange"
                type="daterange"
                size="small"
                value-format="yyyy-MM-dd"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                range-separator="-"
                :start-placeholder="$l('INDEX.label_beginDate') || '开始日期'"
                :end-placeholder="$l('INDEX.label_endDate') || '结束日期'"
                style="width: 100%"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col :span="24" class="mt-3">
            <el-form-item :label="$l('table_label_regionName') || '市场'">
              <dict-select
                v-model="formData.regionCodeList"
                :body="{ dictType: 'region' }"
                url="/master/common/dict/biz"
                :placeholder="
                  $l('form_label_selectregionname ') || '请选择市场'
                "
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>

          <el-col :span="24" class="mt-3">
            <el-form-item :label="$l('table_label_storeName') || '门店'">
              <dict-select
                v-model="formData.storeCodeList"
                url="/ecom/amz/store/select"
                :placeholder="$l('form_label_selectstorename') || '请选择门店'"
                filterable
                clearable
                multiple
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="24" class="mt-3">
            <el-form-item :label="$l('INDEX.type') || '类型'">
              <dict-select
                v-model="formData.types"
                :body="{ dictType: 'amzOrderType' }"
                url="/sys/common/dict/system"
                :options="{ label: 'value', value: 'value' }"
                :placeholder="
                  $l('form_placeholder_select_type') || '请选择类型'
                "
                multiple
                filterable
                clearable
                size="small"
                style="width:100%"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" type="primary" @click="advquery">{{
          '生成导出文件'
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'

// 初始表单
export default {
  mixins: [EditLoading],

  data() {
    return {
      advqueryDialogVisible: false,
      formData: {
        dateRange: [],
        types: ['Order'],
        storeCodeList: [],
        regionCodeList: [],
      },
      dateRange: [],
      rules: {
        dateRange: [
          {
            required: true,
            message: '需要输入日期',
          },
        ],
      },
    }
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query')
    },
    async advquery() {
      const { dateRange = [] } = this.formData
      if (!dateRange || !dateRange.length) {
        return this.$message.error(
          this.$l('INDEX.form_label_any_required_fields_are_not_filled_in') ||
            '有必输字段未填写，请检查'
        )
      }
      const [begin, end] = dateRange || []
      this.formData.beginDate = begin
      this.formData.endDate = end

      const context = { ...this.formData }
      this.loadingOpen()
      this.$api
        .SYS_EXPORT_TASK('factory-ecom-order-board', context)
        .then((res) => {
          this.loadingClose()
          const { status } = res || {}
          if (200 === status) {
            this.$message({
              message:
                this.$l('INDEX.added_to_the_download_center') ||
                '导出任务已经添加到下载中心，请稍后从下载中心下载文件',
              type: 'success',
            })
            this.closeAdvqueryDialog()
            return
          }
          this.$message.error(
            this.$l(
              'INDEX.dialog_title_Description_Failed_to_add_export_task'
            ) || '导出任务添加失败'
          )
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(
            this.$l(
              'INDEX.dialog_title_Description_Failed_to_add_export_task'
            ) || '导出任务添加失败'
          )
        })
      this.closeAdvqueryDialog()
    },
    openAdvqueryDialog({
      dateRange,
      beginDate,
      endDate,
      storeCodeList,
      regionCodeList,
      types,
    }) {
      this.formData.dateRange = dateRange
      this.formData.beginDate = beginDate
      this.formData.endDate = endDate
      this.advqueryDialogVisible = true
      this.formData.storeCodeList = storeCodeList
      this.formData.regionCodeList = regionCodeList
      this.formData.types = types
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form .el-form-item {
  margin-bottom: 0 !important;
}
</style>
